import { CSSProperties } from "react";
import { AgentIcon, FactionType } from "~/business";
import { Colors, Spacing } from "~/jsx/theme";
import { expectNever, parseEnumOrError } from "~/utils";

export const XActionSlotSection = ({
  children,
  agentIcon,
  style,
}: {
  children: React.ReactNode;
  agentIcon: AgentIcon;
  style?: CSSProperties;
}) => {
  const color = getBackgroundColor(agentIcon);
  return (
    <div
      style={{
        padding: Spacing.actions,
        width: "fit-content",
        backgroundColor: color,
        ...style,
      }}
    >
      {children}
    </div>
  );
};

const getBackgroundColor = (agentIcon: AgentIcon): string => {
  switch (agentIcon) {
    case AgentIcon.Emperor:
    case AgentIcon.SpacingGuild:
    case AgentIcon.BeneGesserit:
    case AgentIcon.Fremen:
      return Colors.faction[parseEnumOrError(FactionType, agentIcon)].dark;
    case AgentIcon.SpiceTrade:
    case AgentIcon.City:
    case AgentIcon.Landsraad:
      return Colors.agentIcon[agentIcon].dark;
    default:
      expectNever(agentIcon);
      throw new Error();
  }
};
